import { MixSettingsJarFullness } from "../entities/Mix";
import { toFixedNumber } from "./toFixedNumber";

export const getCalculatedJarFullness = (
  weight: number,
  totalWeight: number,
): MixSettingsJarFullness => {
  const percentage = toFixedNumber((weight / totalWeight) * 100, 2);

  if (percentage === 0) {
    return MixSettingsJarFullness.EMPTY;
  }

  if (percentage === 100) {
    return MixSettingsJarFullness.FULL;
  }

  if (percentage >= 75) {
    return MixSettingsJarFullness.THREE_QUARTERS;
  }

  if (percentage >= 50) {
    return MixSettingsJarFullness.HALF;
  }

  if (percentage >= 25) {
    return MixSettingsJarFullness.ONE_QUARTER;
  }

  return MixSettingsJarFullness.EMPTY;
};
